module.exports = __webpack_public_path__ + "img/book-skull.882acc47.svg";